import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { num } from "../../utils";
import "./style.scss";
import { isBankCardExpired } from "../../utils/siteUtils";

/**
 * @param card {BankCard}
 * @param expiredText {string}
 * @return {JSX.Element}
 * @constructor
 */
const BankCardInformation = ({ card, expiredText }) => {
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    if (card?.expirationMonth) {
      const _isExpired = isBankCardExpired(card.expirationYear, card.expirationMonth);
      setIsExpired(_isExpired);
    }
  }, [card]);
  const cardNameClasses = classNames("card-name-wrapper", isExpired ? "expired" : "");
  return (
    <div className="bank-card-information">
      <div className={cardNameClasses}>
        <p className="card-name">{card?.cardMethodName}</p>
        {isExpired && <p className="expired-text">{expiredText?.value || "Expired"}</p>}
      </div>
      <p>**** **** **** {card?.cardNo}</p>
      <p>{card?.cardHolder}</p>
      <p>{card?.formattedExpireDate}</p>
    </div>
  );
};
export default BankCardInformation;
